export default __webpack_public_path__ + "static/media/reward-2.8eaace4e.png";